<template>
    <div class="bg-primary">
        <div class="container space-top-1 pb-3">
            <div class="row">
                <div class="col-lg-5 order-lg-2 text-lg-right mb-4 mb-lg-0">
                    <div class="d-flex d-lg-inline-block justify-content-between justify-content-lg-end align-items-center align-items-lg-start">
                        <!-- Breadcrumb -->
                        <ol class="breadcrumb breadcrumb-white breadcrumb-no-gutter mb-0">
                            <li class="breadcrumb-item">
                                <router-link class="breadcrumb-link" :to="{'name': 'home'}">Accueil</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Éditer profil</li>
                        </ol>
                        <!-- End Breadcrumb -->

                        <!-- Breadcrumb Nav Toggle Button -->
                        <div class="d-lg-none">
                            <button type="button" class="navbar-toggler btn u-hamburger u-hamburger--white"
                                    aria-label="Toggle navigation"
                                    aria-expanded="false"
                                    aria-controls="breadcrumbNavBar"
                                    data-toggle="collapse"
                                    data-target="#breadcrumbNavBar">
                      <span id="breadcrumbHamburgerTrigger" class="u-hamburger__box">
                        <span class="u-hamburger__inner"></span>
                      </span>
                            </button>
                        </div>
                        <!-- End Breadcrumb Nav Toggle Button -->
                    </div>
                </div>

                <div class="col-lg-7 order-lg-1">
                    <!-- User Info -->
                    <div class="media d-block d-sm-flex align-items-sm-center">
                        <div class="u-lg-avatar position-relative mb-3 mb-sm-0 mr-3">
                            <img class="img-fluid rounded-circle" :src="avatarDisplayUrl" alt="Image Description">
                            <span class="badge badge-md badge-outline-success badge-pos badge-pos--bottom-right rounded-circle">
                      <span class="fas fa-check"></span>
                    </span>
                        </div>
                        <div class="media-body">
                            <h1 class="h3 text-white font-weight-medium mb-1">Salut, {{ user.info.profile.displayName }}!</h1>
                            <span class="d-block text-white">{{ user.info.email }}</span>
                        </div>
                    </div>
                    <!-- End User Info -->
                </div>
            </div>
        </div>

        <div class="container space-bottom-1 space-bottom-lg-0">
            <div class="d-lg-flex justify-content-lg-between align-items-lg-center">
                <!-- Navbar -->
                <div class="u-header u-header-left-aligned-nav u-header--bg-transparent-lg u-header--white-nav-links z-index-4">
                    <div class="u-header__section bg-transparent">
                        <nav class="js-breadcrumb-menu navbar navbar-expand-lg u-header__navbar u-header__navbar--no-space">
                            <div id="breadcrumbNavBar" class="collapse navbar-collapse u-header__navbar-collapse">
                                <ul class="navbar-nav u-header__navbar-nav">
                                    <!-- Paramètres du compte -->
                                    <li class="nav-item hs-has-sub-menu u-header__nav-item"
                                        data-event="hover"
                                        data-animation-in="slideInUp"
                                        data-animation-out="fadeOut">
                                        <a id="accountSettingsDropdown" class="nav-link u-header__nav-link u-header__nav-link-toggle" href="javascript:;" aria-haspopup="true" aria-expanded="false" aria-labelledby="accountSettingsDropdownMenu">
                                            Paramètres du compte
                                        </a>

                                        <ul id="accountSettingsDropdownMenu" class="hs-sub-menu u-header__sub-menu u-header__sub-menu--spacer" style="min-width: 230px;" aria-labelledby="accountSettingsDropdown">
                                            <li><a class="nav-link u-header__sub-menu-nav-link" href="edit-profile.html">Edit profile</a></li>
                                            <li><a class="nav-link u-header__sub-menu-nav-link" href="change-password.html">Change password</a></li>
                                            <li><a class="nav-link u-header__sub-menu-nav-link" href="notifications.html">Notifications</a></li>
                                        </ul>
                                    </li>
                                    <!-- Paramètres du compte -->
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
                <!-- End Navbar -->

                <div class="ml-lg-auto">
                    <!-- Button -->
                    <router-link class="btn btn-sm btn-soft-white text-nowrap transition-3d-hover"
                                 :to="{'name': 'viewProfile', 'params': {'username': user.info.username}}">
                        Voir mon profil
                    </router-link>
                    <!-- End Button -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import {ASSETS_FOLDER} from "../settings";

    export default {
        name: "EditProfileBreadcumb",
        computed: {
            ...mapState([
                'user'
            ]),
            avatarDisplayUrl: function () {
                const avatarUrl = this.$store.state.user.info.profile.avatarUrl;
                return avatarUrl ? avatarUrl : `${ASSETS_FOLDER}/img/160x160/anonymous_user.png`
            }
        }
    }
</script>

<style scoped>

</style>